import styles from "./index.module.scss";

export default function Loader() {
  return (
    <div className={styles.wrapper} data-e="notes-loader">
      <div className={styles.line1}></div>
      <div className={styles.line2}></div>
      <div className={styles.line3}></div>
    </div>
  );
}
